/**
 * @fileoverview EntityWithIcon — inline row used inside Control Panel
 * cards to label an entity (enrollment, organization, etc.): leading
 * Blueprint icon + bold truncated name.
 *
 * Foundry mapping: `control-panel-components__entity-with-icon__q5g46y`
 * + `__icon` + bold strong.
 */

import { Icon, type IconName } from "@blueprintjs/core";
import type { ReactElement, ReactNode } from "react";

interface EntityWithIconProps {
  icon: IconName;
  name: ReactNode;
  className?: string;
}

export function EntityWithIcon({
  icon,
  name,
  className,
}: EntityWithIconProps): ReactElement {
  return (
    <div data-testid="entity-with-icon" className={["bp-entity-with-icon", className].filter(Boolean).join(" ")}>
      <Icon icon={icon} />
      <div className="bp6-text-overflow-ellipsis">
        <strong>{name}</strong>
      </div>
    </div>
  );
}
